import { CopyOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Image, List, Typography } from 'antd';
import type { UploadedFileInfo } from '../hooks/useFileUpload';

const { Paragraph } = Typography;

interface UploadResultListProps {
	uploadedFiles: UploadedFileInfo[];
	onCopyUrl: (url: string) => void;
	onRemove: (uid: string) => void;
}

export function UploadResultList({
	uploadedFiles,
	onCopyUrl,
	onRemove,
}: UploadResultListProps) {
	if (uploadedFiles.length === 0) {
		return null;
	}

	return (
		<Card title="上传结果">
			<List
				dataSource={uploadedFiles}
				renderItem={(item) => (
					<List.Item
						actions={[
							<Button
								key="copy"
								type="link"
								icon={<CopyOutlined />}
								onClick={() => onCopyUrl(item.url)}
							>
								复制链接
							</Button>,
							<Button
								key="delete"
								type="link"
								danger
								icon={<DeleteOutlined />}
								onClick={() => onRemove(item.uid)}
							>
								移除
							</Button>,
						]}
					>
						<List.Item.Meta
							avatar={
								item.isImage ? (
									<Image
										src={item.url}
										width={60}
										height={60}
										style={{ objectFit: 'cover' }}
									/>
								) : null
							}
							title={item.name}
							description={
								<div>
									<Paragraph
										copyable={{ text: item.url }}
										ellipsis={{ rows: 1, expandable: true }}
										style={{ marginBottom: 6 }}
									>
										{item.url}
									</Paragraph>
									{item.isImage && item.width && item.height ? (
										<Typography.Text type="secondary">
											尺寸：{item.width} × {item.height}
										</Typography.Text>
									) : null}
								</div>
							}
						/>
					</List.Item>
				)}
			/>
		</Card>
	);
}
